/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IPromisePeriod, PromisePeriod } from '../../../app-data/models/PromisePeriod';
import { child } from '@angular/fire/database';

export class PromisePeriodList extends FancyFirebaseSplitDataList<
	IPromisePeriod,
	DefaultSplitDataRenderType,
	PromisePeriod
> {
	public currentPromisePeriodId: string;
	public lockedPromisePeriodId: string;

	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		super(angularLand, path, fancyJoins);
	}

	/**
	 * Event that is dispatched when a new object is added to Firebase
	 * We use this event to assign the currentPromisePeriodId/lockedPromisePeriodId data sources
	 * by also invoking checkCurrentPeriod();
	 * @param action
	 */
	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>): PromisePeriod {
		const promisePeriod: PromisePeriod = new PromisePeriod(action.payload.key);
		const data: IPromisePeriod = action.payload.val() as IPromisePeriod;
		promisePeriod.databaseUpdate(data);
		this.checkCurrentPeriod(action.key, data);
		return promisePeriod;
	}

	/**
	 * Add a hook for $$updated so we can update current/locked promise period IDs on change
	 * @param child
	 * @param action
	 */
	public override $$updated(child: PromisePeriod, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
		this.checkCurrentPeriod(child.$id, child.view);
	}

	private checkCurrentPeriod(id: string, data: IPromisePeriod): void {
		// If this promise period is not locked, then that means this is the next promise period (can be dragged/edited)
		if (!data.locked) {
			this.currentPromisePeriodId = id;
			return;
		}
		// Otherwise this is a locked promise period
		this.lockedPromisePeriodId = id;
	}
}
